export default __webpack_public_path__ + "static/media/Arm_left.6cf3b9b0.svg";